import React from "react";
import { Box } from "@mui/material";
import { useResponsiveFontSize } from "../functions";

const TextDisplay = ({ textArray, margin, color, fontWeight }) => {
  const fontSize = useResponsiveFontSize();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
        gap: 2,
        width: "90%",
        margin: "auto",
        marginTop: margin,
        marginBottom: margin,
        fontSize: fontSize,
        fontWeight: fontWeight,
      }}
    >
      {textArray.map((text, index) => (
        <Box
          key={index}
          sx={{
            display: "grid",
            placeItems: "center",
            textAlign: "center",
            color: color,
            marginBottom: "10px",
          }}
        >
          {text}
        </Box>
      ))}
    </Box>
  );
};

export default TextDisplay;
